"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

exports.__esModule = true;
exports.default = exports.BlogPostTemplate = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _react = _interopRequireWildcard(require("react"));

var _reactStatic = require("react-static");

var _mobxReact = require("mobx-react");

var _PostInfo = require("./PostInfo/PostInfo");

var _ReactStaticPage = require("../page/ReactStaticPage");

var _Core = require("../../components/Core");

var _Blog = require("../../site/coffee/pages/blog/Blog");

var _Breadcrumbs = require("../../components/Breadcrumb/Breadcrumbs");

var _class;

var BlogPostTemplate = (0, _mobxReact.observer)(_class =
/*#__PURE__*/
function (_Component) {
  (0, _inheritsLoose2.default)(BlogPostTemplate, _Component);

  function BlogPostTemplate(props) {
    return _Component.call(this, props) || this;
  }

  var _proto = BlogPostTemplate.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        post = _this$props.post,
        postsPath = _this$props.postsPath,
        children = _this$props.children,
        otherProps = (0, _objectWithoutProperties2.default)(_this$props, ["post", "postsPath", "children"]);
    return _react.default.createElement(_ReactStaticPage.ReactStaticPage, (0, _extends2.default)({
      title: post.title
    }, otherProps), _react.default.createElement(_Core.Box, {
      mb: 4
    }, _react.default.createElement(_Breadcrumbs.Breadcrumbs, {
      items: [{
        label: _Blog.BlogMenuTitle,
        to: postsPath
      }]
    }), _react.default.createElement(_PostInfo.PostInfo, {
      postInfo: post.postInfo
    })), _react.default.createElement("div", null, children && children));
  };

  return BlogPostTemplate;
}(_react.Component)) || _class;

exports.BlogPostTemplate = BlogPostTemplate;

var _default = (0, _reactStatic.withRouteData)(BlogPostTemplate);

exports.default = _default;